import { AppActionType } from "../actiontype/app.actiontype";
import CommonActionType from "../actiontype/common.actiontype";

const initialState = {
  displayLoader: false,
  displayHeader: true,
  displayFooter: true,
  msisdn: '',
  platformType: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AppActionType.SHOW_LOADER:
      return {
        ...state,
        displayLoader: action.payload
      };
    case AppActionType.HIDE_LOADER:
      return {
        ...state,
        displayLoader: action.payload
      };
    case AppActionType.SHOW_HEADER:
      return {
        ...state,
        displayHeader: action.payload
      };
    case AppActionType.HIDE_HEADER:
      return {
        ...state,
        displayHeader: action.payload
      };
    case AppActionType.SHOW_FOOTER:
      return {
        ...state,
        displayFooter: action.payload
      };
    case AppActionType.HIDE_FOOTER:
      return {
        ...state,
        displayFooter: action.payload
      };
    case AppActionType.SET_MSISDN:
      return {
        ...state,
        msisdn: action.payload
      }; 
    case CommonActionType.SET_PLATFORM_TYPE:
      return {
        ...state,
        platformType: action.payload
      }
    case CommonActionType.RESET_STATE:
      return { ...state, ...initialState }
    default:
      return state;
  }
};
